





















































import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import VatsAPI from '@/Shared/VatsAPI';
import buildEntityComponentMixin from '@/Shared/CommonEntityMixins/EntityComponentMixin';
import { CreditHoldRequest } from '@/Payment/CreditHoldRequest';
import { getValidationErrors } from '@/Shared/ValidationErrorDirective';
import { AxiosResponse } from 'axios';
import { PaymentMethod } from '@/Payment/Enums';
import { LetterType } from '@/Letters/Enums';
import { PaymentResult } from '@/Payment/PaymentResult';

const component = mixins(LocationBasedMixin, buildEntityComponentMixin<CreditHoldRequest>()).extend({
    props: {
        holdId: {
            type: String,
            required: true,
        },
        receiptId: {
            type: Number,
            required: false
        }
    },
    computed: {
        entityUrls(): string {
            return `${this.location}/Payments/HoldRequest/${this.holdId}`;
        }
    },
    data() {
        return {
            i18nPrefix: 'payment.citationPayment.bootRelease.completion',
            releaseCodes: [] as string[],
            LetterType,
            messages: [] as string[],
            emailAddress: null as string | null,
            emailing: false,
        };
    },
    methods: {
        afterLoad(response: AxiosResponse<CreditHoldRequest>) {
            this.loadMessages(response.data.requestId);
            response.data.dateRequested = new Date(response.data.dateRequested);
            if (response.data.holdSuccessful) {
                this.loadReleaseCodes(response.data.requestId);
            }
            return response.data;
        },
        async loadMessages(requestId: string) {
            try {
                const path = `${this.location}/CitationPayments/${PaymentMethod.Card}/BootRelease/Completion/ReleaseMessages`;
                const params = { holdRequestId: requestId };
                const response = await VatsAPI.get<string[]>(path, {
                    params
                });
                this.messages = response.data;
            }
            catch (e) {
                const translatedTitle = this.$i18n.t(`${this.i18nPrefix}.messageLoadFailedTitle`);
                const translatedMessage = this.$i18n.t(`${this.i18nPrefix}.messageLoadFailedMessage`);
                this.$bvToast.toast(translatedMessage.toString(), {
                    title: translatedTitle.toString(),
                    autoHideDelay: 5000
                });
                throw e;
            }
        },
        async loadReleaseCodes(requestId: string) {
            try {
                const path = `${this.location}/CitationPayments/${PaymentMethod.Card}/BootRelease/Completion/ReleaseCodes`;
                const params = { holdRequestId: requestId };
                const response = await VatsAPI.get<string[]>(path, {
                    params
                });

                this.releaseCodes = response.data;
            }
            catch (e) {
                const translatedTitle = this.$i18n.t(`${this.i18nPrefix}.releaseCodeLoadFailedTitle`);
                const translatedMessage = this.$i18n.t(`${this.i18nPrefix}.releaseCodeLoadFailedMessage`);
                this.$bvToast.toast(translatedMessage.toString(), {
                    title: translatedTitle.toString(),
                    autoHideDelay: 5000
                });
                throw e;
            }
        },
        async sendEmails() {
            const releaseCodeEmailUrl =
                `${this.location}/CitationPayments/${PaymentMethod.Card}/BootRelease/Completion/Email`;
            const releaseCodeEmailParams = {
                holdRequestId: this.entity.requestId
            };

            await this.sendEmail(releaseCodeEmailUrl, releaseCodeEmailParams);

            const receiptEmailUrl = `${this.location}/Letters/${LetterType.BootReleaseHoldReceipt}/${this.receiptId}/Email`;
            await this.sendEmail(receiptEmailUrl);
        },
        async sendEmail(url: string, params: any = {}) {
            this.validationErrors = {};
            this.emailing = true;
            try {
                await VatsAPI.post(url, JSON.stringify(this.emailAddress), {
                    headers: {
                        ['content-type']: 'application/json',
                    },
                    params: {...params}
                });

                const translatedTitle = this.$i18n.t(`${this.i18nPrefix}.emailSuccessfulTitle`);
                const translatedMessage = this.$i18n.t(`${this.i18nPrefix}.emailSuccessfulMessage`, {
                    address: this.emailAddress
                });
                this.$bvToast.toast(translatedMessage.toString(), {
                    title: translatedTitle.toString(),
                    autoHideDelay: 5000
                });
            }
            catch (e) {
                this.validationErrors = getValidationErrors(e.response);
                const translatedTitle = this.$i18n.t(`${this.i18nPrefix}.emailFailedTitle`);
                const translatedMessage = this.$i18n.t(`${this.i18nPrefix}.emailFailedMessage`);
                this.$bvToast.toast(translatedMessage.toString(), {
                    title: translatedTitle.toString(),
                    autoHideDelay: 5000
                });
                throw e;
            }
            finally {
                this.emailing = false;
            }
        }
    }
});

export default component;
